import React, { useState } from 'react';
import { Event, EventBase } from '../../../../../model/event';
import { Card } from '../../../../../components/Card/Card';
import { t } from '../../../../../locales/translate';
import { KeyValueTable } from '../../../../../components/KeyValueTable/KeyValueTable';
import { formatDateTime } from '../../../../../util/util';
import { ControlledModal } from '../../../../../components/Modal/ControlledModal';
import { ShippableFromForm } from './Modals/ShippableFromForm';
import { Icon } from '../../../../../components/Icon/Icon';

interface Props {
  event: Event;
}

export function ShippableFrom({ event }: Props): JSX.Element {
  const [displayModal, setDisplayModal] = useState(false);

  return (
    <Card title={t.model.product.shippableFrom} actions={<Icon name="edit" onClick={() => setDisplayModal(true)} />}>
      <KeyValueTable
        items={[
          {
            key: t.model.product.shippableFrom,
            value: formatDateTime(event.shippableFrom),
          },
          {
            key: t.model.product.publicShippableFrom,
            value: event.publicShippableFrom ? formatDateTime(event.publicShippableFrom) : t.general.notAvailable,
          },
          {
            key: t.model.product.dhlShippableFrom,
            value: event.dhlShippingFrom ? formatDateTime(event.dhlShippingFrom) : t.general.notAvailable,
          },
        ]}
      ></KeyValueTable>
      <ControlledModal<EventBase>
        open={displayModal}
        model={event}
        onClose={() => setDisplayModal(false)}
        title={t.actions.edit(t.model.product.shippableFrom)}
        size="small"
      >
        {(controller) => <ShippableFromForm controller={controller} />}
      </ControlledModal>
    </Card>
  );
}
